import {DetailTable} from '../../../mapping-classes/detail-table';

export class Requestedcards implements DetailTable {
  /* TODO: change to credit card context*/
  shieldedText = '';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  /*
  TODO: Implement PyshicalCard Model
  * */
  constructor(requestedPhisicalCards: any) {
    if (!requestedPhisicalCards || requestedPhisicalCards.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = requestedPhisicalCards.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(requestedPhisicalCards);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'securedCardNumber',
      'type',
      'status',
      'pinRequestDate',
      'pinRegistrationDateTime',
      'pinNotificationDateTime',
      'registrationPassFactoryDateTime',
      'notificationPassFactoryDateTime',
      'shippingAddress',
      'requestReason',
    ];
  }

  setRowData(requestedPhysicalCards) {
    requestedPhysicalCards.forEach((requestedPhysicalCard) => {
      if (this.restrictedData) {
        requestedPhysicalCard.compensationLimit = this.shieldedText;
        requestedPhysicalCard.actualBalance = this.shieldedText;
      }
      this.rowData.push(requestedPhysicalCard);
    });
  }
}
